import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { HttpClientService } from 'src/app/@shared/services/http-client/http-client.service';
import { LogService } from 'src/app/@shared/services/log/log.service';
import { RoutePlanning } from '../interfaces/route-planning/@route-planning.interface';
import { GetRouteRequest } from '../interfaces/route-planning/service/@route-planning-service.interface';
import { environment } from 'src/environments/environment';
import { HttpHandler, HttpParams } from '@angular/common/http';
import { SpecialMessage } from '../interfaces/route-planning/gtfs/special-messages/special-message.interface';
import { AgencyContactInfo } from '../interfaces/route-planning/agency-contact-info.interface';
import { Price } from '../interfaces/route-planning/price.interface';
import { Rating } from '../interfaces/route-planning/rating.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Address } from '../interfaces/location/address.interface';
import { City } from '../interfaces/location/city.interface';
import { PointOfInterest } from '../interfaces/location/point-of-interest.interface';
import { Stop } from '../interfaces/route-planning/gtfs/stop.interface';
import { Route } from '../interfaces/route-planning/gtfs/route.interface';
import { Coordinate } from '../interfaces/location/coordinate.interface';

@Injectable({
  providedIn: 'root',
})
export class AutoCompleteRepository {
  constructor(
    private readonly httpClientService: HttpClientService,
    httpHandler: HttpHandler,
    languageService: LanguageService
  ) {
    this.httpClientService = new HttpClientService(httpHandler, languageService);
    this.httpClientService.apiUrl = environment.auto_complete_service_url;
  }

  searchLocations(searchTerm: string): Observable<ServiceResponse<Address[]>> {
    LogService.logInfo('searchLocations searchTerm', searchTerm);
    return this.httpClientService.mot_get('AutoComplete/SearchLocations', new HttpParams().append('searchTerm', searchTerm));
  }

  searchCities(searchTerm: string): Observable<ServiceResponse<City[]>> {
    LogService.logInfo('searchLocations searchTerm', searchTerm);
    return this.httpClientService.mot_get('AutoComplete/SearchCities', new HttpParams().append('searchTerm', searchTerm));
  }

  searchPointsOfInterest(searchTerm: string): Observable<ServiceResponse<PointOfInterest[]>> {
    LogService.logInfo('searchPointsOfInterest searchTerm', searchTerm);
    return this.httpClientService.mot_get('AutoComplete/SearchPointsOfInterest', new HttpParams().append('searchTerm', searchTerm));
  }

  searchStation(searchTerm: string): Observable<ServiceResponse<Stop[]>> {
    LogService.logInfo('searchStations searchTerm', searchTerm);
    return this.httpClientService.mot_get('AutoComplete/SearchStations', new HttpParams().set('searchTerm', searchTerm));
  }

  searchLines(searchTerm: string): Observable<ServiceResponse<Route[]>> {
    LogService.logInfo('searchLines searchTerm', searchTerm);
    return this.httpClientService.mot_get('AutoComplete/SearchLines', new HttpParams().set('searchTerm', searchTerm));
  }

  addMissingSearch(searchText: string): Observable<ServiceResponse<void>> {
    LogService.logInfo('addMissingSearch searchText', searchText);
    return this.httpClientService.mot_post(`AutoComplete/AddMissingSearch?searchText=${encodeURIComponent(searchText)}`);
  }

  getAddressDataByCoordinates(
    coordinates: Coordinate
  ): Observable<ServiceResponse<Address>> {
    return this.httpClientService.mot_get<ServiceResponse<Address>>(
      'AutoComplete/GetAddressDataByCoordinates',
      new HttpParams()
        .append('lat', coordinates.lat)
        .append('lng', coordinates.lng)
    );
  }
}



